import { Styles, ImageStyle } from '@bonanza-social/moonlight';
import { Rule } from './PrizeWallQuickRule.types';

export const ARROW_STYLE: Record<
  Rule,
  Pick<Styles<ImageStyle>, 'width' | 'height' | 'left' | 'right' | 'transform'>
> = {
  quickRuleArrowLeft: {
    width: 104,
    height: 104,
    left: 'space-600',
    transform: `translateY(${104}px)`,
  },
  quickRuleArrowRight: {
    width: 112,
    height: 112,
    right: 'space-600',
    transform: `translateY(${116}px)`,
  },
};
